import { memo } from 'react';

import { Input } from '..';
import Modal from '../common/modal';
import { useLogic } from './download-personal-info.logic';
import { TDownloadPersonalInfoProps } from './download-personal-info.type';

const DownloadPersonalInfoView = ({
	title = '다운로드 사유',
	className,
	...props
}: TDownloadPersonalInfoProps) => {
	const { loading, reason, handleClick, handleInputChange } = useLogic(props);

	return (
		<Modal
			width={600}
			title={title}
			labelButton="다운로드"
			onClickButton={handleClick}
			destroyOnClose
			loading={loading}
			{...props}
		>
			<ul className="font-medium mb-5 text-sm leading-[26px] whitespace-pre-line list-disc pl-6 text-[13px]">
				<li>
					파일을 다운로드 하려면 개인정보 보호를 위해 사유를 입력해야 합니다.
				</li>
				<li>입력된 내용은 감사기능 메뉴에 저장됩니다.</li>
			</ul>
			<Input maxLength={50} value={reason} onChange={handleInputChange} />
		</Modal>
	);
};

export default memo(DownloadPersonalInfoView);
